// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import "core-js/es6/promise";
import "core-js/es6/string";
import "core-js/es7/array";
// import cssVars from 'css-vars-ponyfill'
import Vue from "vue";
import BootstrapVue from "bootstrap-vue";
import App from "./App";
import router from "./router";
import VueResource from "vue-resource";
import VueSweetalert2 from "vue-sweetalert2";
import Multiselect from "vue-multiselect";
import JsonExcel from "vue-json-excel";
import UploadFile from "@/components/UploadFile.vue";
import Calendar from "@/components/Calendar.vue";
import datePicker from "vue-bootstrap-datetimepicker"; // https://www.npmjs.com/package/vue-bootstrap-datetimepicker
import VueMask from "v-mask";
import VoerroTagsInput from "@voerro/vue-tagsinput"; // https://github.com/voerro/vue-tagsinput
import FullCalendar from "vue-full-calendar"; // https://www.npmjs.com/package/vue-full-calendar
// import vSelect from 'vue-select'// https://www.npmjs.com/package/vue-select
import VueFormWizard from "vue-form-wizard"; //https://binarcode.github.io/vue-form-wizard/?ref=madewithvuejs.com#/
import { VueReCaptcha } from "vue-recaptcha-v3";

// import VueGoodTablePlugin from 'vue-good-table';

//PLANTILLA: https://coreui.io/docs/2.1/components/tooltips/

const options = {
  confirmButtonColor: "#41b882",
  cancelButtonColor: "#ff7674"
};

Vue.prototype.$reload = { value: true };
// Vue.prototype.$urlApi = "http://127.0.0.1:8000/api/";
Vue.prototype.$urlApi = "https://devapi.treboljuridico.com/api/";
Vue.prototype.$maxMinutes = 10000000000000; // 570

//import 'vue-select/dist/vue-select.css';

// todo
Vue.use(VueResource);
Vue.use(BootstrapVue);
Vue.use(datePicker);
Vue.use(VueMask);
Vue.use(FullCalendar);
Vue.use(VueSweetalert2, options);
Vue.use(VueFormWizard);
// Vue.use(VueGoodTablePlugin);
Vue.component("multiselect", Multiselect);
Vue.component("downloadExcel", JsonExcel);
Vue.component("uploadFile", UploadFile);
Vue.component("tags-input", VoerroTagsInput);
Vue.component("calendar", Calendar);
Vue.component("pagination", require("laravel-vue-pagination")); // https://github.com/gilbitron/laravel-vue-pagination
Vue.use(VueReCaptcha, {
  siteKey: "6LcHmKQZAAAAAK7oqkCG1iHi2BPxAzl4c65GePkH",
  loaderOptions: {
    useRecaptchaNet: true
  }
});

//Vue.component('v-select', vSelect)

// INTERCEPTOR, SE EJECUTA ANTES DE UNA PETICION HTTP
Vue.http.interceptors.push((request, next) => {
  next(response => {
    if (response.status == 401) {
      swal({
        title: "Sesión",
        text: "Su sesión ha caducado!",
        icon: "warning",
        button: "Aceptar"
      }).then(value => {
        localStorage.clear();
        sessionStorage.clear();
        location.href = `${location.origin}/#/login`;
        location.reload();
      });
    }
  });
});

const print = {};

function printSection(el, binding) {
  // insertar css especial para la impresión, esto mostrar un contenedor especial y ocultara el resto de contenido
  let style = document.createElement("style");
  style.type = "text/css";
  style.appendChild(
    document.createTextNode(
      "@media screen{#printSection{display:none}}@media print{#printSection,body{overflow:visible!important}body *{visibility:hidden}#printSection,#printSection *{visibility:visible}#printSection{position:absolute;left:0;top:0;right:0}#printSection table{width:100%!important}}"
    )
  );
  document.body.appendChild(style);

  // busco si existe mi sección para imprimir
  let printSection = document.getElementById("printSection");

  // si no existe la creo y la inserto en el body
  if (!printSection) {
    printSection = document.createElement("div");
    printSection.id = "printSection";
    document.body.appendChild(printSection);
  }

  // creo el evento del click para cada que se de click en imprimir
  el.addEventListener("click", () => {
    // busco el contenido a imprimir, esto ya que como parametro tenia el id
    var elemToPrint = document.getElementById(binding.value);

    //si existe el contenido entonces lo imprimiré
    if (elemToPrint) {
      printSection.innerHTML = ""; // limpio el contenido anterior de mi sección a imprimir
      printElement(elemToPrint);
    }
  });

  // funcion para imprimir
  function printElement(elem) {
    // creo un nodo y lo inserto dentro de mi sección a imprimir
    let domClone = elem.cloneNode(true);
    printSection.appendChild(domClone);
    window.print(); //mando a imprimir
  }
}

Vue.directive("print", {
  bind(el, binding) {
    printSection(el, binding);
  }
});

/* eslint-disable no-new */
new Vue({
  el: "#app",
  router,
  template: "<App/>",
  components: {
    App
  }
});
